/* eslint-disable no-shadow */

export const MAX_POSITION_LENGTH = 50;
export const PHONE_NUMBER_LENGTH = 11;

export enum UserRoles {
  admin = 10,
  user = 20,
}
